import React from 'react';
import styles from './Header.module.css';
import { useGetSelfQuery } from '../../../../../redux/services/TraderApi';
import formatNumber from '../../../../../utils/functions/formatNumber';
import { Loading } from '../../../../../components/Loading/Loading';
import type { TMerchantCurrencyRate } from '../../../../../redux/types/MerchantTypes';

const RateValue = ({ value, tone }: { value: string | null; tone: 'income' | 'outcome' }) => (
  <span className={`${styles.rateValue} ${styles[tone]}`}>
    <img
      src={tone === 'income' ? '/greenArrowIcon.svg' : '/redArrowIcon.svg'}
      alt=''
      aria-hidden='true'
    />
    {value === null ? '—' : formatNumber(value)}
  </span>
);

const CurrencyRateCard = ({ rate }: { rate: TMerchantCurrencyRate }) => (
  <article className={styles.rateCard}>
    <div className={styles.currencyTitle}><strong>USDT–{rate.code}:</strong> <span>{rate.order_rate === null ? '—' : formatNumber(rate.order_rate)}</span></div>
    <div className={styles.rateGrid}>
      <span>Пополнение:</span>
      <RateValue value={rate.order_rate} tone='income' />
      <span>Выплата:</span>
      <RateValue value={rate.withdrawal_rate} tone='outcome' />
    </div>
    <small className={styles.source}>{rate.order_source || rate.withdrawal_source || 'Источник не назначен'}</small>
  </article>
);

const SelfRates: React.FC = () => {
  const { data: selfData, isLoading: selfLoading, isError, refetch } = useGetSelfQuery(undefined, {
    pollingInterval: 10000,
  });

  if (selfLoading) {
    return <Loading />;
  }
  if (isError || !selfData) {
    return <div className={styles.errorState} role='alert'>
      <span>Не удалось загрузить курсы</span>
      <button type='button' onClick={refetch}>Повторить</button>
    </div>;
  }

  const legacyDepositRate = selfData.hybrid_deposit_rate || selfData.bybit_deposit_rate
    || selfData.htx_deposit_rate || selfData.rapira_deposit_rate || 0;
  const legacyWithdrawalRate = selfData.hybrid_withdrawal_rate || selfData.bybit_withdrawal_rate
    || selfData.htx_withdrawal_rate || selfData.rapira_withdrawal_rate || 0;
  const currencyRates = selfData.currency_rates?.length ? selfData.currency_rates : [{
    code: 'RUB',
    name: 'Российский рубль',
    order_rate: String(legacyDepositRate),
    withdrawal_rate: String(legacyWithdrawalRate),
    order_source: null,
    withdrawal_source: null,
    orders_enabled: true,
    withdrawals_enabled: true,
  }];

  return (
    <section className={styles.wrapper} aria-labelledby='merchant-rates-title'>
      <div className={styles.heading}>
        <h2 id='merchant-rates-title'>Курсы</h2>
        <small>Ставки по подключённым валютам</small>
      </div>
      <div className={styles.cards}>
        {currencyRates.map(rate => <CurrencyRateCard key={rate.code} rate={rate} />)}
      </div>
    </section>
  );
};

export default SelfRates;
